import axios from 'axios';

const getSolicitacao = requestId => axios.get(`/external/solicitacao/${requestId}`);
const recusar = (requestId, data) => axios.put(`/external/resposta/situacao/${requestId}`, data);

export default {
  getSolicitacao,
  recusar,
};
